export default __webpack_public_path__ + "static/media/books-41.61271757.jpg";